<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<div class="resize" [class.fill]="fill">
  <mat-card-header>
    <mat-card-title>{{ cardTitle }}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="card-content">
    <ng-content></ng-content>
  </mat-card-content>
</div>
